import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import classnames from "classnames";
import * as React from "react";

import "./style.less";

export type MovementProps = { value: number };
const Movement = (props: MovementProps) => (
  <span
    className={classnames("movement", {
      down: props.value < 0,
      up: props.value >= 0
    })}
  >
    {props.value < 0 ? <Icon icon={IconType.CaretDown} /> : <Icon icon={IconType.CaretUp} />}
    {Math.abs(props.value)}
  </span>
);
export default Movement;
